import { render, staticRenderFns } from "./ContentTypeFieldsetOffcanvas.vue?vue&type=template&id=dfaa351c"
import script from "./ContentTypeFieldsetOffcanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentTypeFieldsetOffcanvas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports